import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description UserProfile icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { UserProfile } from '@sravni/design-system-icons'
 *
 * <UserProfile />
 * ```
 */
var UserProfile = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "UserProfile", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.833 17.5H4.167c-.921 0-1.667-.746-1.667-1.667V4.167c0-.921.746-1.667 1.667-1.667h11.666c.921 0 1.667.746 1.667 1.667v11.666c0 .921-.746 1.667-1.667 1.667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12.063 6.206a2.917 2.917 0 1 1-4.125 4.125 2.917 2.917 0 0 1 4.125-4.125ZM14.51 15.024a2.678 2.678 0 0 0-.67-.976 2.674 2.674 0 0 0-1.82-.716H7.98a2.678 2.678 0 0 0-2.492 1.692", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { UserProfile };
//# sourceMappingURL=UserProfile.js.map
